<div class="bg-white background">
</div>
<app-menu-template2>
  <main class="container-fluid">
    <header class="row bg-header">
      <div class="col-2 m-auto">
        <img class="col-sm-12 p-0 mt-4 ml-3" src="../../../../../assets/images/legislacion-01.png" />
      </div>
      <div class="col-10 m-auto">
        <p class="m-0 ml-4">Registro Nacional de Turismo</p>
        <h1 class="m-0 font-weight-bold ml-4">Términos y condiciones de uso</h1>
      </div>
    </header>
    <app-menu-template4 [terminos]="terminos" (clickCollapse)="onCollase($event)">

        <div class="col-12 border-bottom mb-3" *ngFor="let item of terminos; let num = index">
          <header>
            <a class="text-primary d-flex" (click)="onCollase(item)" [attr.aria-expanded]="!item.collapse"
              [attr.aria-controls]="'pregunta_'+num">
              <h5 *ngIf="item.collapse" class="font-weight-bold pointer">+</h5>
              <h5 *ngIf="!item.collapse" class="font-weight-bold pointer">-</h5>
              <h5 class="ml-2 pointer mb-3">{{item.titulo}}</h5>
            </a>
          </header>
          <aside [id]="'pregunta_'+num" [ngbCollapse]="item.collapse">
            <div class="card border-0 p-0">
              <div class="card-body p-0">
                <ng-container *ngFor="let itemT of item.terminos">
                  <p class="text-muted" [innerHTML]="itemT.descripcion"></p>
                </ng-container>
              </div>
            </div>
          </aside>
        </div>
  </app-menu-template4>
  </main>
</app-menu-template2>
